import Vue from 'vue';
import add1 from './common-icon-add/add1';

Vue.component(add1.name, add1);
